<template>
  <van-popup position="bottom" v-model="isShow">
    <div class="container f28">
      <div class="title">选择地址</div>
      <div class="close" @click="hide"></div>
      <div class="addr-container">
        <ul>
          <div class="mt30 f32 bold">默认</div>
          <li><addr-com selected/></li>
        </ul>
        <ul>
          <div class="mt30 f32 bold">其他</div>
          <li>
            <addr-com/>
          </li>
          <li>
            <addr-com/>
          </li>
          <li>
            <addr-com/>
          </li>
          <li>
            <addr-com/>
          </li>
        </ul>
      </div>
      <button class="submit btn-black-round" disabled @click="hide">确认寄回</button>
    </div>
  </van-popup>
</template>

<script>
  import { Popup } from 'vant'
  export default {
    name: 'cancelOrder',
    components: {
      'van-popup': Popup
    },
    data () {
      return {
        isShow: false
      }
    },
    methods: {
      show () {
        this.isShow = true
      },
      hide () {
        this.isShow = false
      }
    }
  }
</script>

<style scoped lang="scss">
  .van-popup--bottom{
    width: 101%;
  }
  .container{
    height: 860px;
    padding: 30px;
    position: relative;
    .title{
      line-height: 40px;
      margin-bottom: 50px;
    }
    .addr-container{
      height: 700px;
      overflow-y: scroll;
      ul li{
        width: 100%;
        display: flex;
        align-items: center;
      }
    }
    .close{
      width: 36px;
      height: 36px;
      position: absolute;
      top: 30px;
      right: 30px;
      background: url("/images/public/close.png") no-repeat center;
      background-size: 32px;
    }
    .submit{
      position: absolute;
      bottom: 30px;
      right: 30px;
    }
  }
</style>
